import useSWR, { mutate } from 'swr';
// import { useMemo } from 'react';

//========================================
//=          DYNAMIC IMPORT MASTER MENU         =
//========================================
import { useMemo, useState, useEffect } from 'react';
import { transformModulesToMenu } from '../utils/tranformModuleToMenu';

// Project-imports
// import { fetcher } from 'utils/axios'; //static menu

const initialState = {
  isDashboardDrawerOpened: false,
  isComponentDrawerOpened: true
};

const endpoints = {
  key: 'api/menu',
  master: 'master',
  dashboard: '/dashboard' // server URL
};
// const staticMenuItem = {
//   id: 'invoice1',
//   title: 'invoice',
//   type: 'item',
//   url: '/dashboard/invoice',
//   breadcrumbs: false
// };

// export function useGetMenu() {
//   const { data, isLoading, error, isValidating } = useSWR(endpoints.key + endpoints.dashboard, fetcher, {
//     revalidateIfStale: false,
//     revalidateOnFocus: false,
//     revalidateOnReconnect: false
//   });

//   const memoizedValue = useMemo(() => {
//     let updatedMenu = data?.dashboard;

//     if (updatedMenu && Array.isArray(updatedMenu.children) && updatedMenu.children.length > 0) {
//       updatedMenu = {
//         ...updatedMenu,
//         children: updatedMenu.children.map((group) => {
//           if (Array.isArray(group.children)) {
//             return {
//               ...group,
//               children: [...group.children, staticMenuItem]
//             };
//           }
//           return group;
//         })
//       };
//     }

//     return {
//       menu: updatedMenu,
//       menuLoading: isLoading,
//       menuError: error,
//       menuValidating: isValidating,
//       menuEmpty: !isLoading && !data?.length
//     };
//   }, [data, error, isLoading, isValidating]);

//   return memoizedValue;
// }

// export function useGetMenuMaster() {
//   const { data, isLoading } = useSWR(endpoints.key + endpoints.master, () => initialState, {
//     revalidateIfStale: false,
//     revalidateOnFocus: false,
//     revalidateOnReconnect: false
//   });

//   const memoizedValue = useMemo(
//     () => ({
//       menuMaster: data,
//       menuMasterLoading: isLoading
//     }),
//     [data, isLoading]
//   );

//   return memoizedValue;
// }

//========================================
//=          DYNAMIC MASTER MENU         =
//========================================
export function useGetMenu() {
  const [menu, setMenu] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const raw = localStorage.getItem('master_menu');
      if (raw) {
        const modules = JSON.parse(raw);
        if (Array.isArray(modules) && modules.length > 0) {
          const transformed = transformModulesToMenu(modules); // { groups, translations }
          const groups = Array.isArray(transformed?.groups) ? transformed.groups : Array.isArray(transformed) ? transformed : [];
          setMenu(groups);
          try {
            localStorage.setItem('menu_translations', JSON.stringify(transformed?.translations || {}));
          } catch (e) {
            console.log(e);
          }
          return;
        }
      }
      // jika tidak ada modules => pastikan menu tetap array kosong
      setMenu([]);
    } catch (e) {
      console.error('Gagal membaca menu dari localStorage', e);
      setMenu([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const memoizedValue = useMemo(
    () => ({
      menu,
      menuLoading: loading,
      menuError: null,
      menuEmpty: !loading && (!menu || menu.length === 0)
    }),
    [menu, loading]
  );

  return memoizedValue;
}

export function useGetMenuMaster() {
  const { data, error, isLoading } = useSWR(
    endpoints.key + endpoints.master,
    () => {
      try {
        const saved = localStorage.getItem('menu_master_state');
        if (saved) {
          return { ...initialState, ...JSON.parse(saved) };
        }
      } catch (e) {
        console.log('updated menuMaster:', e);
      }
      return initialState;
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );

  const menuMaster = data ?? initialState;

  return {
    menuMaster,
    menuMasterLoading: isLoading,
    menuMasterError: error
  };
}

export function handlerComponentDrawer(isComponentDrawerOpened) {
  // to update local state based on key

  mutate(
    endpoints.key + endpoints.master,
    (currentMenuMaster) => {
      return { ...currentMenuMaster, isComponentDrawerOpened };
    },
    false
  );
}

export function handlerDrawerOpen(isDashboardDrawerOpened) {
  // to update local state based on key

  mutate(
    endpoints.key + endpoints.master,
    (currentMenuMaster) => {
      return { ...currentMenuMaster, isDashboardDrawerOpened };
    },
    false
  );
}
